import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"


export default {
  __name: 'BaseInputGroup',
  props: {
  /**
   * Permette di aggiungere delle classi personalizzate sia nell'input group before che after
   * @example {before: 'crm:flex ...', after: {'crm:inline-block ...'}}
   */
  classes: {
    type: Object,
    default() {
      return {}
    }
  },
  /**
   * Se true non mostra i bordi tra gli input
   */
  isNoBorder: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

/**
 * @doc
 * Gestisce la visualizzazione simil input group di bootstrap ma in un fighissimo Tailwind
 */
const props = __props

const defaultClasses = {
  before: props.classes.before,
  after: props.classes.after
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$slots['before'])
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["crm:bg-rowHover crm:p-2 crm:border crm:border-rowHover crm:lg:w-auto", [defaultClasses.before, !__props.isNoBorder ? 'crm:lg:rounded-bl-md crm:lg:rounded-tl-md' : '']])
        }, [
          _createCommentVNode(" @slot permette di inserire un elemento prima del principale "),
          _renderSlot(_ctx.$slots, "before")
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" @slot permette di inserire un elemento principale "),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.$slots['after'])
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["crm:bg-rowHover crm:p-2 crm:border crm:border-rowHover crm:lg:w-auto", [defaultClasses.after, !__props.isNoBorder ? 'crm:lg:rounded-br-md crm:lg:rounded-tr-md' : '']])
        }, [
          _createCommentVNode(" @slot permette di inserire un elemento dopo il principale "),
          _renderSlot(_ctx.$slots, "after")
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}